import { Link, useLocation } from 'react-router-dom';
import websitelogo from '../assets/websitelogo.png';

const Sidebar = ({ children }) => {
  const location = useLocation();

  const linkStyle = {
    textDecoration: 'none',
    color: 'black',
    fontWeight: 'bold',
  };

  const activeLinkStyle = {
    fontWeight: 'bold',
    color: 'white',
  };

  return (
    <div style={{ display: 'flex' }}>
      <div style={{
        width: '200px',
        height: '100vh',
        padding: '20px',
        backgroundColor: '#FFC300',
        position: 'fixed',
      }}>
        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 35 }}>
          <img style={{ height: 45, width: 45 }} alt={'logo'} src={websitelogo}/>
          <div style={{ fontWeight: 'bold', fontSize: 34, marginLeft: 5, marginTop: 5 }}>Vasco</div>
        </div>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Link
            to="/dashboard"
            style={location.pathname === "/dashboard" ? activeLinkStyle : linkStyle}
          >
            Delivery Feed
          </Link>
          <Link
            to="/dashboard/users"
            style={location.pathname === "/dashboard/users" ? activeLinkStyle : linkStyle}
          >
            Users
          </Link>
          <Link
            to="/dashboard/projects"
            style={location.pathname === "/dashboard/projects" ? activeLinkStyle : linkStyle}
          >
            Projects
          </Link>
          <Link
            to="/dashboard/vendors"
            style={location.pathname === "/dashboard/vendors" ? activeLinkStyle : linkStyle}
          >
            Vendors
          </Link>
          <Link
            to="/dashboard/subcontractors"
            style={location.pathname === "/dashboard/subcontractors" ? activeLinkStyle : linkStyle}
          >
            Subcontractors
          </Link>
          <Link
            to="/dashboard/settings"
            style={location.pathname === "/dashboard/settings" ? activeLinkStyle : linkStyle}
          >
            Settings
          </Link>
        </nav>
      </div>
      <div style={{ flex: 1, padding: '20px', marginLeft: '220px' }}>
        {children}
      </div>
    </div>
  );
}

export default Sidebar;


